import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import "./Navbar.css";
import { useAuth } from "./context/AuthContext.tsx";
import LoginModal from "./components/auth/LoginModal.tsx";

const Navbar = ({ toggleSidebar, isSidebarOpen }: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem("darkMode");
    return saved === "true"; // localStorage stores strings
  });
  const [showLoginModal, setShowLoginModal] = useState(false);

  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const toggleMenu = () => setIsOpen(!isOpen);
  const toggleProfile = () => setProfileOpen(!profileOpen);
  const toggleTheme = () => {
    setDarkMode(!darkMode);
  };

  const handleLogin = () => {
    setShowLoginModal(true);
  };

  const handleSignOut = async () => {
    await logout();
    setProfileOpen(false);
    navigate('/');
  };

  useEffect(() => {
    document.body.classList.toggle("dark-theme", darkMode);
    localStorage.setItem("darkMode", darkMode.toString()); // ✅ explicitly convert to string
  }, [darkMode]);

  return (
    <nav className="navbar ">
      <div className={`nav-left ${isOpen ? "open" : ""}`}>
        <button className="menu-toggle" onClick={toggleSidebar}>
          ☰
        </button>
        <h2 className="brand-text"><span className="brand-swing">SwingSetup</span> <span className="brand-ai">AI</span></h2>
      </div>

      <div className={`nav-links ${isOpen ? "open" : ""}`}>
        <NavLink to="/" className={({ isActive }) =>
          isActive ? "active" : ""
        } onClick={() => setIsOpen(false)}>Home</NavLink>
        {!user?.isPremium && (
          <NavLink to="/pricing" className={({ isActive }) => isActive ? "active" : "" } onClick={() => setIsOpen(false)}>Pricing</NavLink>
        )}
        {/* Hidden for now
        <NavLink to="/about" className={({ isActive }) => isActive ? "active" : "" } onClick={() => setIsOpen(false)}>About Us</NavLink>
        */}

        <div className="dropdown">
          <Link to="#" className="nav-link">
            More ▾
          </Link>
          <div className="dropdown-content">
            {/* Hidden for now
            <NavLink to="/blog" onClick={() => setIsOpen(false)}>Blog</NavLink>
            */}
            <NavLink to="/contact" onClick={() => setIsOpen(false)}>Contact</NavLink>
            <NavLink to="/faq" onClick={() => setIsOpen(false)}>FAQ</NavLink>
          </div>
        </div>
      </div>

      <div className="nav-actions">
        <button className="theme-toggle" onClick={toggleTheme}>
          {darkMode ? "🌙" : "☀️"}
        </button>

        {/* Profile Dropdown */}
        {isAuthenticated && user ? (
          <div className="profile-dropdown">
            <button className="profile-icon" onClick={toggleProfile}>
              👤
            </button>
            {profileOpen && (
              <div className="profile-menu">
                <div className="profile-header">
                  <div className="profile-avatar">
                    {user.profilePhoto ? (
                      <img src={user.profilePhoto} alt="Profile" className="avatar-img" />
                    ) : (
                      <div className="avatar-placeholder">
                        {user.name.charAt(0).toUpperCase()}
                      </div>
                    )}
                  </div>
                  <div className="profile-details">
                    <div className="profile-name">{user.name}</div>
                    {/* <div className="profile-email">{user.email || user.username || ''}</div> */}
                  </div>
                </div>
                <div className="profile-plan-badge">
                  <span className="plan-icon">💎</span>
                  <span className="plan-text">
                    {user.isPremium
                      ? (user.planName || 'Premium Plan')
                      : 'Free Plan'}
                  </span>
                </div>
                {user.isPremium && (
                  <div className="subscription-details">
                    <div className="subscription-expiry">
                      <span className="expiry-label">Joined at:</span>
                      <span className="expiry-date">
                        {user.createdDate
                          ? new Date(user.createdDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
                          : '—'}
                      </span>
                    </div>
                    {user.expiryDate && (
                      <div className="subscription-expiry">
                        <span className="expiry-label">Expires on:</span>
                        <span className="expiry-date">
                          {new Date(user.expiryDate).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                          })}
                        </span>
                      </div>
                    )}
                  </div>
                )}
                {!user.isPremium && (
                  <button className="upgrade-btn" onClick={() => { navigate('/pricing'); setProfileOpen(false); }}>
                    <span className="upgrade-icon">⚡</span>
                    Upgrade to Premium
                  </button>
                )}
                <button className="signout-btn" onClick={handleSignOut}>
                  <span className="signout-icon">➜]</span>
                  Sign Out
                </button>
              </div>
            )}
          </div>
        ) : (
          <button className="login-btn" onClick={handleLogin}>
            Login
          </button>
        )}

        <button className="menu-toggle" onClick={toggleMenu}>
          ☰
        </button>
      </div>

      {/* Login Modal */}
      <LoginModal isOpen={showLoginModal} onClose={() => setShowLoginModal(false)} />
    </nav>
  );
};

export default Navbar;
